import { Modal } from 'antd';
import { useState } from 'react';
import { TeambinderApiService } from '@src/api';
import 'cleave.js/dist/addons/cleave-phone.kr';
import Cleave from 'cleave.js/react';

interface PhoneNumberModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}

const PhoneNumberModal = ({ open, onCancel, onOk }: PhoneNumberModalProps) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    if (!/^(01[016789]{1})[0-9]{3,4}[0-9]{4}$/.test(phoneNumber)) {
      alert('핸드폰 번호 형식이 올바르지 않습니다.');
      return;
    }

    try {
      setIsLoading(true);
      await TeambinderApiService.modifyPhoneNumber({
        requestBody: { phoneNumber },
      });
      onOk();
    } catch (error) {
      console.error('핸드폰 번호 저장 실패:', error);
      alert('핸드폰 번호 저장에 실패했습니다. 다시 시도해주세요.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title="전화번호 등록"
      open={open}
      onCancel={onCancel}
      onOk={handleSave}
      okText="저장"
      cancelText="나중에"
      okButtonProps={{
        style: {
          backgroundColor: '#4403B5',
          borderColor: '#4403B5',
        },
        loading: isLoading,
        disabled: !phoneNumber,
      }}
      width={416}
      centered
    >
      <div
        style={{
          paddingTop: '8px',
          paddingBottom: '16px',
        }}
      >
        <p style={{ marginBottom: '16px', color: 'rgba(0, 0, 0, 0.85)' }}>
          전화번호를 등록해주세요!
          <br />
          키워드에 새로운 소식이 있을때 알림톡을 발송해드립니다.
        </p>
        <Cleave
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.rawValue)}
          placeholder="010-1234-5678"
          options={{
            phone: true,
            phoneRegionCode: 'KR',
            delimiter: '-',
          }}
          className="ant-input ant-input-lg"
          style={{
            width: '100%',
          }}
        />
      </div>
    </Modal>
  );
};

export default PhoneNumberModal;
